/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { useReactiveVar } from '@apollo/client';
import * as React from 'react';

import {
    templateInstanceIconBackgroundColorVar,
    templateInstanceIconNameVar,
} from '../../../apollo/reactiveVariables/TemplateInstanceVariables';
import { modalDataVar } from '../../../apollo/reactiveVariables/TemplateManagementVariables';
import {
    TemplateInstanceIconPickerComponent,
    TemplateInstanceIconPickerComponentProps,
} from './TemplateInstanceIconPicker.component';

export const TemplateInstanceIconPickerContainer: React.FC = (): JSX.Element => {
    const defaultColor = useReactiveVar(templateInstanceIconBackgroundColorVar);
    const defaultIcon = useReactiveVar(templateInstanceIconNameVar);

    const [selectedColor, setSelectedColor] = React.useState(defaultColor);
    const [selectedIcon, setSelectedIcon] = React.useState(defaultIcon);

    const onDone = (): void => {
        templateInstanceIconBackgroundColorVar(selectedColor);
        templateInstanceIconNameVar(selectedIcon);
        modalDataVar({ isOpen: false });
    };

    const onCancel = (): void => {
        modalDataVar({ isOpen: false });
    };

    const onColorSelected = (color: string): void => {
        setSelectedColor(color);
    };

    const onIconSelected = (iconName: string): void => {
        setSelectedIcon(iconName);
    };

    const componentProps: TemplateInstanceIconPickerComponentProps = {
        selectedColor,
        selectedIcon,
        onDone,
        onCancel,
        onColorSelected,
        onIconSelected,
    };

    return <TemplateInstanceIconPickerComponent {...componentProps} />;
};
